var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticClass:"el-block",attrs:{"options":_vm.area,"props":_vm.props},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }